import _ from 'lodash';
import { getColor } from 'common/constants/_colors';
import DropdownArrowLess from '@material-ui/icons/ExpandLess';
import DropdownArrowMore from '@material-ui/icons/ExpandMore';

const DEFAULT_WIDTH = '20rem';
const MAX_WIDTH = '25rem';

export const styles = () => {
  const waikawaGrayColor = getColor('waikawaGray');
  const zirconColor = getColor('zircon');
  const dodgerBlueColor = getColor('dodgerBlue');
  const catskillGrayColor = getColor('catskillGray');
  const catskillWhiteColor = getColor('catskillWhite');
  const botticelliColor = getColor('botticelli');
  const selectedInput = {
    color: waikawaGrayColor,
    borderRadius: 4,
    border: `1px solid ${dodgerBlueColor} !important`,
    backgroundColor: zirconColor
  };
  const defaultInput = {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    borderRadius: 4,
    height: '100%',
    padding: '0.5rem 2.5rem 0.5rem 1rem !important',
    border: `1px solid ${botticelliColor}`,
    '&:focus, &:hover:not(.Mui-disabled)': selectedInput
  };

  const defaultMenuItem = {
    width: 'calc(100% - 1rem)',
    fontSize: '1.1rem',
    height: '3.7rem',
    lineHeight: '3.7rem',
    margin: '0.5rem',
    paddingRight: '1rem'
  };

  const defaultMenuItemSmall = {
    fontSize: '1.1rem',
    height: 'unset',
    lineHeight: 'unset',
    margin: '0.5rem',
    paddingRight: '1rem'
  };

  const arrowIcon = {
    fontSize: '1.6rem',
    position: 'absolute',
    right: '0.8rem',
    pointerEvents: 'none',
    color: waikawaGrayColor
  };

  return {
    menuItemRoot: {
      ...defaultMenuItem,
      '&:hover': {
        backgroundColor: catskillGrayColor
      }
    },
    menuItemRootSmall: {
      ...defaultMenuItemSmall,
      '&:hover': {
        backgroundColor: catskillGrayColor
      }
    },
    menuItemSelected: {
      ...defaultMenuItem,
      backgroundColor: `${catskillWhiteColor} !important`
    },
    menuItemOpened: {
      ...defaultMenuItem,
      backgroundColor: `${catskillGrayColor} !important`
    },
    menuItemMultipleSelected: {
      ...defaultMenuItem,
      backgroundColor: 'transparent !important'
    },
    menuItemSelectedSmall: {
      ...defaultMenuItemSmall,
      backgroundColor: `${catskillWhiteColor} !important`
    },
    menuItemMultipleSelectedSmall: {
      ...defaultMenuItemSmall,
      backgroundColor: 'transparent !important'
    },
    selectedInput,
    fullWidth: { width: '100%' },
    defaultWidth: { width: DEFAULT_WIDTH },
    autoWidth: { width: 'auto', maxWidth: MAX_WIDTH },
    input: defaultInput,
    noPaddingInput: {
      ...defaultInput,
      padding: 0
    },
    arrowIcon,
    arrowIconDisabled: {
      ...arrowIcon,
      color: getColor('silverSand')
    },
    arrowIconlarge: {
      ...arrowIcon,
      fontSize: '2.5rem'
    },
    arrowIconmedium: {
      ...arrowIcon
    },
    arrowIconsmall: {
      ...arrowIcon
    }
  };
};

export const getArrowClasses = ({ isOpen, classes, disabled, size = 'medium' }) => {
  const arrowDisabledClasses = classes?.arrowIconDisabled;
  const arrowClasses = _.get(classes, [`arrowIcon${size}`]);

  return isOpen ? (
    <DropdownArrowLess
      classes={{
        root: disabled ? arrowDisabledClasses : arrowClasses
      }}
    />
  ) : (
    <DropdownArrowMore
      classes={{
        root: disabled ? arrowDisabledClasses : arrowClasses
      }}
    />
  );
};

export const getInputClasses = (
  width,
  classes,
  isOpen,
  inputProps = {},
  handleWidth = true
) => {
  const returnedClasses = inputProps.noPadding
    ? [classes.noPaddingInput]
    : [classes.input];
  if (handleWidth) {
    if (!width) {
      returnedClasses.push(classes.defaultWidth);
    } else {
      returnedClasses.push(
        width === 'auto' ? classes.autoWidth : classes.fullWidth
      );
    }
  }
  if (isOpen) {
    returnedClasses.push(classes.selectedInput);
  }
  return { input: returnedClasses.join(' ') };
};

export const getMenuItemClasses = ({ menuProps, classes, multiple }) => {
  return {
    root: menuProps.smallItems
      ? classes.menuItemRootSmall
      : classes.menuItemRoot,

    selected: multiple
      ? menuProps.smallItems
        ? classes.menuItemMultipleSelectedSmall
        : classes.menuItemMultipleSelected
      : menuProps.smallItems
      ? classes.menuItemSelectedSmall
      : classes.menuItemSelected
  };
};

export const getMultiLevelMenuItemClasses = ({
  classes,
  isSelected,
  isOpenedParent
}) => {
  return {
    root: isSelected
      ? classes.menuItemSelected
      : isOpenedParent
      ? classes.menuItemOpened
      : classes.menuItemRoot
  };
};

export const getMenuProps = ({ menuHeight, padding }) => {
  return {
    marginThreshold: 0,
    anchorOrigin: {
      vertical: 'bottom',
      horizontal: 'left'
    },
    getContentAnchorEl: null,
    MenuListProps: {
      style: {
        ...(menuHeight ? { maxHeight: menuHeight } : {}),
        ...(padding ? { padding } : {})
      }
    }
  };
};

export const getDropdownStyles = ({ width, height = 'inharit' }) => {
  return {
    width: width ? width : '100%',
    height,
    maxWidth: width ? width : MAX_WIDTH
  };
};
